var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronTopBottomIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A090D92C-15E3-43B6-864D-F9F1A6FC3E43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-OV-CECEU---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main---Home",
    transform: "translate(-311.000000, -224.000000)",
    fill: "#555555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forms/Text-input-small",
    transform: "translate(32.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(279.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron_top_bottom_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38710056,14.3797046 C7.77939176,14.0746797 8.34662282,14.1024093 8.70710678,14.4628932 L8.70710678,14.4628932 L11.832,17.5885292 L14.9159102,14.5049345 L15.0101176,14.4217459 C15.4024088,14.116721 15.9696398,14.1444506 16.3301238,14.5049345 C16.7206481,14.8954588 16.7206481,15.5286238 16.3301238,15.9191481 L16.3301238,15.9191481 L12.5396359,19.7096359 L12.4454286,19.7928245 C12.0531374,20.0978494 11.4859063,20.0701199 11.1254224,19.7096359 L11.1254224,19.7096359 L7.29289322,15.8771068 L7.20970461,15.7828994 C6.90467972,15.3906082 6.93240926,14.8233772 7.29289322,14.4628932 L7.29289322,14.4628932 Z M12.4454286,4.20970461 L12.5396359,4.29289322 L16.3301238,8.08338107 C16.7206481,8.47390537 16.7206481,9.10707034 16.3301238,9.49759464 C15.9696398,9.8580786 15.4024088,9.88580813 15.0101176,9.58078324 L14.9159102,9.49759464 L11.832,6.414 L8.70710678,9.53963593 C8.34662282,9.9001199 7.77939176,9.92784943 7.38710056,9.62282454 L7.29289322,9.53963593 C6.93240926,9.17915197 6.90467972,8.61192092 7.20970461,8.21962971 L7.29289322,8.12542237 L11.1254224,4.29289322 C11.4859063,3.93240926 12.0531374,3.90467972 12.4454286,4.20970461 Z",
    id: "\\uD83C\\uDF08Icon"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronTopBottomIc);
export default __webpack_public_path__ + "static/media/chevron_top_bottom_ic.ec61d7ab.svg";
export { ForwardRef as ReactComponent };